import {Category} from "./category";
export class Mailchimp {
    mail_chimp_list_id ? = '';
    list_name ? = '';
    category ? = [Category];
}


// WEBPACK FOOTER //
// ./src/app/type/mailchimp.ts